import { useCallback } from "react";
import { useVoiceChatStore } from "../store/voice-chat-store";

export const useVoiceChat = () => {
  const {
    // States
    isVoiceChatActive,
    isVoiceChatVisible,
    isVoiceChatMinimized,
    isListening,
    isProcessing,
    isWaitingForResponse,
    transcript,
    error,
    audioLevel,
    isSpeaking,
    isTTSLoading,
    hasActiveWidget,
    autoMinimizeOnProducts,
    isMobile,

    // Actions
    startVoiceChat,
    stopVoiceChat,
    closeVoiceChat,
    hideVoiceChat,
    showVoiceChat,
    minimizeVoiceChat,
    maximizeVoiceChat,
    clearTranscript,
    resetTranscript,
    submitTranscript,
    speak,
    stopSpeaking,
    setHasActiveWidget,
    setAutoMinimizeOnProducts,
    minimizeIfHasProducts,
  } = useVoiceChatStore();

  // Optimized actions with useCallback for performance
  const handleStartVoiceChat = useCallback(async () => {
    await startVoiceChat();
  }, [startVoiceChat]);

  const handleStopVoiceChat = useCallback(() => {
    stopVoiceChat();
  }, [stopVoiceChat]);

  const handleCloseVoiceChat = useCallback(() => {
    closeVoiceChat();
  }, [closeVoiceChat]);

  const handleSubmitTranscript = useCallback(
    (text?: string) => {
      submitTranscript(text);
    },
    [submitTranscript]
  );

  const handleSpeak = useCallback(
    async (text: string) => {
      await speak(text);
    },
    [speak]
  );

  const handleMinimizeIfHasProducts = useCallback(
    (products: any[] | undefined) => {
      minimizeIfHasProducts(products);
    },
    [minimizeIfHasProducts]
  );

  return {
    // States
    isVoiceChatActive,
    isVoiceChatVisible,
    isVoiceChatMinimized,
    isListening,
    isProcessing,
    isWaitingForResponse,
    transcript,
    error,
    audioLevel,
    isSpeaking,
    isTTSLoading,
    hasActiveWidget,
    autoMinimizeOnProducts,
    isMobile,

    // Optimized Actions
    startVoiceChat: handleStartVoiceChat,
    stopVoiceChat: handleStopVoiceChat,
    closeVoiceChat: handleCloseVoiceChat,
    hideVoiceChat,
    showVoiceChat,
    minimizeVoiceChat,
    maximizeVoiceChat,
    clearTranscript,
    resetTranscript,
    submitTranscript: handleSubmitTranscript,
    speak: handleSpeak,
    stopSpeaking,
    setHasActiveWidget,
    setAutoMinimizeOnProducts,
    minimizeIfHasProducts: handleMinimizeIfHasProducts,
  };
};
